import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

const useStyles = makeStyles((theme: Theme) => ({
    container: {
        width: "100%",
    },

    helpTextContainer: {
        opacity: 0.7,
        marginTop: 12,
    },

    helpText: {
        fontSize: theme.fontSizes.smd,
    },

    selectMapTextContainer: {
        marginTop: 20,
    },

    selectMapText: {
        fontSize: 16,
        [theme.breakpoints.down("desktop")]: {
            fontSize: theme.fontSizes.md,
        },
    },

    selectOnTheMap: {
        [theme.breakpoints.down("desktop")]: {
            cursor: "pointer",
            textDecoration: "underline",
        },
    },

    map: {
        zIndex: 1,
        marginTop: 8,
        width: "100%",
        height: 225,
        [theme.breakpoints.down("desktop")]: {
            width: "100%",
            height: "calc(100vh - 60px)",
            position: "absolute",
            top: 192,
            left: 0,
        },
    },
    markerIcon: {
        color: "red",
        fontSize: "36px !important",
    },
}));

export default useStyles;
